import React from 'react'

import { Link } from 'react-router-dom'

type Page = "waters" | "mixer"

type Props = {
  active: Page
}

const pages = [
  { id: 'mixer', label: 'Mixer', icon: 'pi pi-fw pi-calendar', url: '/' },
  { id: 'waters', label: 'Waters', icon: 'pi pi-fw pi-home', url: '/waters' },
]

const activeStyle = "underline"

const Item = ({ page, active }: { page: { label: string, url: string }, active: boolean }) => (
  <Link to={page.url}>
    <div className={`h-12 p-2 font-bold ${active ? activeStyle : ""}`}>
      {page.label}
    </div>
  </Link>
)


export const NavBar = ({ active }: Props) => (
  <div className="flex flex-row">
    {
      pages.map(page => (<Item key={page.id} page={page} active={active === page.id} />))
    }
  </div>
)
